import { render, staticRenderFns } from "./AccessManagement.vue?vue&type=template&id=154ec729&"
import script from "./AccessManagement.vue?vue&type=script&lang=js&"
export * from "./AccessManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports